"use client";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export default function IC_EN_10({ width, height }) {
  const { theme } = useTheme();
  const [color, setColor] = useState("#324ba6");

  useEffect(() => {
    setColor(theme === "dark" ? "#324BA6" : "#324ba6");
  }, [theme]);
  return (
    <svg
      id="Capa_1"
      data-name="Capa 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      width={width}
      height={height}
    >
      <defs>
        <style>
          {`.cls-1 {
        stroke-width: 0px;
        fill: ${color};
      }`}
        </style>
      </defs>
      <path
        className="cls-1"
        d="m20.4,26.35c-1.27,0-2.29-1.03-2.29-2.29s1.03-2.29,2.29-2.29,2.29,1.03,2.29,2.29-1.03,2.29-2.29,2.29Zm0-3.62c-.73,0-1.33.6-1.33,1.33s.6,1.33,1.33,1.33,1.33-.6,1.33-1.33c0-.73-.6-1.33-1.33-1.33Z"
      />
      <path
        className="cls-1"
        d="m13.16,26.35c-1.27,0-2.29-1.03-2.29-2.29s1.03-2.29,2.29-2.29,2.29,1.03,2.29,2.29-1.03,2.29-2.29,2.29Zm0-3.62c-.73,0-1.33.6-1.33,1.33s.6,1.33,1.33,1.33,1.33-.6,1.33-1.33c0-.73-.6-1.33-1.33-1.33Z"
      />
      <path
        className="cls-1"
        d="m5.92,26.35c-1.27,0-2.29-1.03-2.29-2.29s1.03-2.29,2.29-2.29,2.29,1.03,2.29,2.29-1.03,2.29-2.29,2.29Zm0-3.62c-.73,0-1.33.6-1.33,1.33s.6,1.33,1.33,1.33,1.33-.6,1.33-1.33-.6-1.33-1.33-1.33Z"
      />
      <path
        className="cls-1"
        d="m.48,30c-.27,0-.48-.22-.48-.48v-10.91c0-.27.22-.48.48-.48h25.37c.27,0,.48.22.48.48v4.97h2.7v-8.44c0-1.75-1.43-3.18-3.18-3.18H4.59c-2.53,0-4.59-2.06-4.59-4.59S2.06,2.77,4.59,2.77h9.08l.08-.32C14.11,1.01,15.41,0,16.9,0h2.77c.27,0,.48.22.48.48v.71h2.06c.27,0,.48.22.48.48s-.22.48-.48.48h-2.06v2.17h2.06c.27,0,.48.22.48.48s-.22.48-.48.48h-2.06v.72c0,.27-.22.48-.48.48h-2.77c-1.49,0-2.79-1.01-3.15-2.45l-.08-.32H4.59c-2,0-3.62,1.63-3.62,3.62s1.63,3.62,3.62,3.62h21.26c2.29,0,4.15,1.86,4.15,4.15v8.93c0,.27-.22.48-.48.48h-3.18v4.97c0,.27-.22.48-.48.48H.48Zm.48-.97h24.4v-9.95H.97v9.95ZM16.9.97c-1.26,0-2.29,1.03-2.29,2.29s1.03,2.29,2.29,2.29h2.29V.97h-2.29Z"
      />
    </svg>
  );
}
